/*
 *
 * Application reducer
 *
 */

import { fromJS } from 'immutable';

import {
  SAVE_PLAN,
} from 'domain/Options/constants';

import {
  SET_APPLICATION_MODE,
  SET_DEBUG_LEVEL,
  SET_TRANSLATION_MODE,
  SET_LOAD_PLAN_FROM_LINK_ERROR,
  SET_LOAD_LOCAL_PLAN_ERROR,
  SET_SAVE_ERROR,
  SHOW_PRICE_DIFFERENCE_DIALOG,
  HIDE_PRICE_DIFFERENCE_DIALOG,
  NORMAL,
  CLOSE_PLAN_SAVED_DIALOG,
  PLAN_LOADING,
  RESET_DIALOGS,
  DISPLAY_VIRTUAL_KEYBOARD,
  DISABLE_PRICE_ANIMATION,
  SHOW_PLAN_SAVED_DIALOG,
  SHOW_NEW_FEATURES_DIALOG,
  SHOW_NEW_FEATURES_TOAST,
  DISPLAY_PRINT_FORMAT,
  SET_IPEXGALLERY_MODE,
  SET_UPPTACKA_MODE,
  SET_IDLE_TIME,
  SET_KIOSK_PRINT_MODE,
} from './constants';

export const initialState = fromJS({
  applicationMode: NORMAL,
  loadPlanFromLinkError: false,
  loadLocalPlanError: false,
  saveError: false,
  redirectAfterSave: true,
  priceDifferenceDialog: {
    visible: false,
  },
  debugLevel: 0,
  translationMode: 'localized',
  planLoading: false,
  displayVirtualKeyboard: false,
  showNewFeaturesDialog: false,
  showNewFeaturesToast: false,
  displayPrintFormat: false,
  showPlanSavedDialog: false,
  cwcalcReachedFromIpexGallery: false,
  idleTime: 60,
  printEnabledOnKiosk: false,
});

function mainPageReducer(state = initialState, action) {
  switch (action.type) {
    case SET_APPLICATION_MODE:
      return state.set('applicationMode', action.mode);
    case SET_DEBUG_LEVEL:
      return state.set('debugLevel', action.debugLevel);
    case SET_TRANSLATION_MODE:
      return state.set('translationMode', action.translationMode);
    case DISPLAY_VIRTUAL_KEYBOARD:
      return state.set('displayVirtualKeyboard', action.display);
    case DISABLE_PRICE_ANIMATION:
      return state.set('disablePriceAnimation', action.disable);
    case SET_LOAD_PLAN_FROM_LINK_ERROR:
      return state.set('loadPlanFromLinkError', action.error);
    case SET_LOAD_LOCAL_PLAN_ERROR:
      return state.set('loadLocalPlanError', action.error);
    case SET_SAVE_ERROR:
      return state.set('saveError', action.error);
    case SHOW_PRICE_DIFFERENCE_DIALOG:
      return state.set('priceDifferenceDialog', fromJS({
        visible: true,
        oldPrice: action.oldPrice,
        oldFamilyPrice: action.oldFamilyPrice,
        oldCurrency: action.oldCurrency,
        oldCountry: action.oldCountry,
      }));
    case HIDE_PRICE_DIFFERENCE_DIALOG:
      return state.setIn(['priceDifferenceDialog', 'visible'], false);
    case SAVE_PLAN:
      return state.set('redirectAfterSave', action.redirect);
    case SHOW_PLAN_SAVED_DIALOG:
      return state.set('showPlanSavedDialog', true);
    case CLOSE_PLAN_SAVED_DIALOG:
      return state.set('showPlanSavedDialog', false);
    case PLAN_LOADING:
      return state.set('planLoading', action.loading);
    case SHOW_NEW_FEATURES_DIALOG:
      return state.set('showNewFeaturesDialog', action.show);
    case SHOW_NEW_FEATURES_TOAST:
      return state.set('showNewFeaturesToast', action.show);
    case RESET_DIALOGS:
      return state.set('saveError', false).set('loadPlanFromLinkError', false).setIn(['priceDifferenceDialog', 'visible'], false).set('showPlanSavedDialog', false);
    case DISPLAY_PRINT_FORMAT:
      return state.set('displayPrintFormat', true);
    case SET_IPEXGALLERY_MODE:
      return state.set('cwcalcReachedFromIpexGallery', action.mode);
    case SET_UPPTACKA_MODE:
      return state.set('cwcalcReachedFromUpptacka', action.mode);
    case SET_IDLE_TIME:
      return state.set('idleTime', action.time);
    case SET_KIOSK_PRINT_MODE:
      return state.set('printEnabledOnKiosk', action.mode);
    default:
      return state;
  }
}

export default mainPageReducer;
